<template>
    <div class="banner-container">
        <el-carousel
            v-if="list?.length"
            ref="carouselRef"
            class="carousel-list"
            :interval="data.intervalTime"
            trigger="click"
            :indicator-position="showBottomIndicators"
            arrow="never"
            @change="onCarouselChanged">
            <el-carousel-item
                v-for="item in list"
                :key="item.id"
                class="carousel-item">
                <img class="carousel-img" :src="item.coverUrl" alt="banner图" @click="goDetail(item)">
            </el-carousel-item>
            <span v-if="showLeftArrow" class="arrow-item flex-center arrow-left" @click.stop="handlePrev"></span>
            <span v-if="showRightArrow" class="arrow-item flex-center arrow-right" @click.stop="handleNext"></span>
        </el-carousel>
        <img v-else class="default-carousel-img" src="~@/assets/img/gateway/banner@2x.png" alt="banner图">
    </div>
</template>

<script setup>
import { goNewsDetail } from '@/lib/tools.js';
import { ref, reactive, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';

const store = useStore();

const list = ref([]); // banner列表数据

let carouselRef = ref(null);

let data = reactive({
    currentBanner: 0,
    intervalTime: 5000
});

// 左侧切换按钮是否显示
let showLeftArrow = computed(() => {
    return list.value?.length > 1 && data.currentBanner > 0;
})

// 右侧切换按钮是否显示
let showRightArrow = computed(() => {
    return list.value?.length > 1 && (list.value?.length - data.currentBanner > 1) ;
})

// 底部切换是否显示
let showBottomIndicators = computed(() => {
    return list.value?.length > 1 ? '' : 'none'
})

// 自动切换幻灯片
function onCarouselChanged (newVal, oldVal) {
    data.currentBanner = newVal;
}

// 切换上一页幻灯片
function handlePrev () {
    carouselRef.value.prev();
}

// 切换下一页幻灯片
function handleNext () {
    carouselRef.value.next();
}

// 跳转banner详情页
function goDetail (info) {
    goNewsDetail(info, 'bannerDetail');
}


const params = {
    instAppTypeId: '3',
    pageIndex: 1,
    pageSize: 6,
    orderType: 'sort',
    publishPlace: 'PC',
    publishState: 1 // 发布状态
}

const getFirstScreenContent = () => {
    G_transmit('getFirstScreenContent', {
        name: 'getFirstScreenContent',
        queries: params
    }).then(res => {
        let result = res?.data?.rows || [];
        result.forEach(item => {
            item.publishTime = dayjs(item.publishTime).format('YYYY.MM.DD');
        })
        list.value = result;
    });
}

onMounted(() => {
    // 获取banner
    getFirstScreenContent();
})
</script>

<style lang="scss" scoped>
.banner-container {
    margin-top: 21px;
    height: 300px;
    border-radius: 4px;
    .default-carousel-img {
        width: 1200px;
        height: 300px;
        border-radius: 4px;
    }
    .carousel-list {
        border-radius: 4px;
        .carousel-item {
            .carousel-img {
                width: 100%;
                height: 100%;
            }
            border-radius: 4px;
        }
        .arrow-item {
            position: absolute;
            height: 50px;
            width: 30px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 2;
            line-height: 50px;
            text-align: center;
            font-size: 14px;
            background: var(--srt-color-black);
            color: #ffffff;
            cursor: pointer;
            opacity: 0.5;
            display: none;
        }
        &:hover {
            .arrow-item {
                display: block;
            }
        }
        .arrow-left {
            left: 0;
            border-radius: 0px 4px 4px 0px;
            &::after {
                content: '';
                background: url(~@/assets/img/home/banner-left.png) no-repeat;
                width: 8px;
                height: 14px;
                display: inline-block;
                background-size: contain;
                vertical-align: middle;
                transform: translateY(1px);
            }
        }
        .arrow-right {
            right: 0;
            border-radius: 0px 4px 4px 0px;
            &::after {
                content: '';
                background: url(~@/assets/img/home/banner-right.png) no-repeat;
                width: 8px;
                height: 14px;
                display: inline-block;
                background-size: contain;
                vertical-align: middle;
                transform: translateY(1px);
            }
        }
        :deep(.el-carousel__indicators) {
            .el-carousel__indicator--horizontal {
                padding: 0 6px 20px;
            }
            .el-carousel__indicator {
                .el-carousel__button {
                    background: rgba(255, 255, 255, 0.6);
                    height: 4px;
                }
                &.is-active {
                    .el-carousel__button {
                        background-color: var(--home-main-color);
                    }
                }

            }
        }
    }
}
</style>